import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContratarRecargaCertaService {

  constructor( private readonly http: HttpClient ) { }


  public getContrato(idEmpresa) {
    return this.http.get(`/apiconnect//importation/order/right-refill-contract/${idEmpresa}/companies`);  
  }

  public getContratar(idEmpresa , idContato , ipOrigem) {
    return this.http.get(`/apiconnect/importation/order/right-refill/${idEmpresa}/companies?idContato=${idContato}&ipOrigem=${ipOrigem}&termo=true`);  
  }

}
